import {Entity} from '@s-ui/domain'

export class PhoneSellerValueObject extends Entity {
  #phone

  constructor({phone}) {
    super()
    this.#phone = phone
  }

  static create({phone}) {
    return new PhoneSellerValueObject({phone})
  }

  get phone() {
    return this.#phone
  }

  get value() {
    return {
      phone: this.#phone
    }
  }

  toJSON() {
    return {phone: this.#phone}
  }
}
